import {SetGetBonusHistoryList} from './thunk/setGetBonusHistoryList';
import {SetGetCashiersProfile} from './thunk/setGetCashiersProfile';
import {SetGetGgr} from './thunk/setGetGgr';
import {SetGetHistoryList} from './thunk/setGetHistoryList'
import {SetGetJackpotHistoryList} from './thunk/setGetJackpotHistoryList';
import {SetGetOperationsReplenishment} from './thunk/setGetOperationsReplenishment'
import {SetGetOperationsWithdrawal} from './thunk/setGetOperationsWithdrawal';

export const Thunks = {
    SetGetBonusHistoryList,
    SetGetCashiersProfile,
    SetGetGgr,
    SetGetHistoryList,
    SetGetJackpotHistoryList,
    SetGetOperationsReplenishment,
    SetGetOperationsWithdrawal
}